import React from 'react';
import {withStyles} from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {BlueButton, GreenButton, GreyButton, OrangeButton} from "../common/ButtonsConstants";
import {
    AddCircleOutlineTwoTone,
    AddCircleTwoTone,
    HighlightOffTwoTone,
    SystemUpdateAltTwoTone
} from "@material-ui/icons";
import TableComponent from "../common/TableComponent";
import TextField from "@material-ui/core/TextField";
import {NotificationContainer, NotificationManager} from "react-notifications";
import moment from "moment";
import {exportReport} from "../../util/ApiUtils";
import {Spinner} from "../common/Spinner";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Modal from "@material-ui/core/Modal";
import CommonRevisionModal from "../common/CommonRevisionModal";
import {
    addDocumentRetentionRevision,
    deleteDocumentRetention,
    documentRetention, documentRetentionRevision,
    saveOrUpdateDocumentRetention
} from "../../util/OperationModuleApiUtils";
import * as CommonUtils from "../../util/CommonUtils";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

const columns = [
    {
        title: 'id',
        field: 'id',
        type: "numeric",
        hidden: true,
    },
    {
        name: 'Record Name',
        id: 'recordName',
        type: "text",
    },
    {
        name: 'Retention period',
        id: 'retentionPeriod',
        type: "text",
    },
    {
        name: 'Person responsible',
        id: 'personResponsible',
        type: "text",
    },
    {
        name: 'Location',
        id: 'location',
        type: "text",
    },
    {
        name: 'Disposal method',
        id: 'disposalMethod',
        type: "text",
    },
];

class DocumentRetention extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            latestRevision: {},
            documentRetentionRecords: [],
            recordName: '',
            retentionPeriod: '',
            personResponsible: '',
            location: '',
            disposalMethod: '',
            isLoading: true,
        };
        this.loadDocumentRetentionRecords = this.loadDocumentRetentionRecords.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onClear = this.onClear.bind(this);
        this.export = this.export.bind(this);
        this.loadDocumentRetentionRevision = this.loadDocumentRetentionRevision.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.addRevision = this.addRevision.bind(this);
        this.myRef = React.createRef()
    }

    showModal() {
        this.setState({
            show: true
        });
    }

    closeModal(updatedRevision) {
        console.log("updatedRevision");
        console.log(updatedRevision);
        if (updatedRevision) {
            this.setState({
                show: false,
                latestRevision: updatedRevision,
            });
        } else {
            this.setState({
                show: false,
            });
        }
    }

    componentDidMount() {
        this.loadDocumentRetentionRecords();
        this.loadDocumentRetentionRevision();
    }

    addRevision(request) {
        addDocumentRetentionRevision(request)
            .then(response => {
                NotificationManager.success('Success', 'The Revision has been updated.', 5000);
                console.log('response');
                console.log(response);
                this.closeModal(response);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    loadDocumentRetentionRevision() {
        documentRetentionRevision()
            .then(response => {
                console.log('document retention revision', response);
                this.setState({
                    latestRevision: response,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    onChange({ target }) {
        this.setState({
            ...this.state, [target.name]: target.value
        });
    }

    loadDocumentRetentionRecords() {
        documentRetention()
            .then(response => {
                this.setState({
                    documentRetentionRecords: response,
                    isLoading: false,
                });
            });
    }

    onClear() {
        this.setState({
            id: null,
            recordName: '',
            retentionPeriod: '',
            personResponsible: '',
            location: '',
            disposalMethod: '',
        });
    }

    onSave() {
        console.log("submitting...");
        const record = {
            id: this.state.id,
            recordName: this.state.recordName,
            retentionPeriod: this.state.retentionPeriod,
            personResponsible: this.state.personResponsible,
            location: this.state.location,
            disposalMethod: this.state.disposalMethod };
        saveOrUpdateDocumentRetention(record)
            .then((project) => {
                this.setState({
                    isLoading: true,
                });
                this.loadDocumentRetentionRecords();
                this.setState({
                    id: null,
                    recordName: '',
                    retentionPeriod: '',
                    personResponsible: '',
                    location: '',
                    disposalMethod: '',
                });
            })
            .catch(error => {
                console.log("error");
                console.log(error);
                NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
            });
    }

    onDelete(record) {
        console.log(record);
        deleteDocumentRetention(record)
            .then(() => {
                NotificationManager.success('Success', 'The Record has been removed.', 5000);
            }).catch(error => {
                NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    onEdit(record) {
        window.scrollTo(0, 0);
        this.setState({
            id: record.id,
            recordName: record.recordName,
            retentionPeriod: record.retentionPeriod,
            personResponsible: record.personResponsible,
            location: record.location,
            disposalMethod: record.disposalMethod,
        });
    }

    export() {
        exportReport('/document-retention/export');
    }

    render() {
        let { state } = this;
        if (state.isLoading) {
            return <Spinner/>;
        }
        console.log("state.documentRetentionRecords", state.documentRetentionRecords);
        const isRevision = (state.latestRevision.id !== null);
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        return <div ref={this.myRef}>
            <Paper className={classes.root}>
                <Card className={classes.card}>
                    {(!state.isEditing ?
                            <CardHeader
                                action={
                                    <BlueButton
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<AddCircleOutlineTwoTone/>}
                                        onClick={this.showModal}
                                        size="small"
                                        style={{marginRight: '10px'}}
                                        disabled={isAuditor}
                                    >
                                        ADD
                                    </BlueButton>
                                }
                                title={
                                    <span style={{color: "darkblue"}}>
                                        <p><b>{isRevision && `Revision ${state.latestRevision.number} Author: ${state.latestRevision.author}`}</b></p>
                                        <p><b>Approved for suitability and adequacy by: {state.latestRevision.approvedBy} on {moment(state.latestRevision.date).format('DD/MM/YYYY')}</b></p>
                                    </span>
                                }
                            />
                            :
                            <CardHeader
                                style={{ paddingBottom: "0px", paddingLeft: "46px" }}
                                title={
                                    <span style={{color: "darkblue"}}>
                                    <p><b>{state.header}</b></p>
                                </span>
                                }
                            />
                    )}
                    <CardContent>
                {!isAuditor && <React.Fragment>
                <Typography variant="h6" style={{ paddingTop: '30px', paddingLeft: "30px" }}>
                    ADD DOCUMENT RETENTION AND DISPOSITION RECORD
                </Typography>
                <div style={{ paddingLeft: "30px", paddingRight: "30px",  paddingBottom: "30px"}}>
                    <div>
                        <div style={{ paddingTop: "20px"}}>
                            <TextField
                                id="recordName"
                                name="recordName"
                                value={state.recordName}
                                label="Record name"
                                onChange={this.onChange}
                                style={{ width: "600px"}}
                            />
                        </div>
                        <div style={{ paddingTop: "20px"}}>
                            <TextField
                                id="retentionPeriod"
                                name="retentionPeriod"
                                value={state.retentionPeriod}
                                label="Retention period"
                                onChange={this.onChange}
                                style={{ width: "600px"}}
                            />
                        </div>
                        <div style={{ paddingTop: "20px"}}>
                            <TextField
                                id="personResponsible"
                                name="personResponsible"
                                value={state.personResponsible}
                                label="Person responsible"
                                onChange={this.onChange}
                                style={{ width: "600px"}}
                            />
                        </div>
                        <div style={{ paddingTop: "20px"}}>
                            <TextField
                                id="location"
                                name="location"
                                value={state.location}
                                label="Location"
                                onChange={this.onChange}
                                style={{ width: "600px"}}
                            />
                        </div>
                        <div style={{ paddingTop: "20px"}}>
                            <TextField
                                id="disposalMethod"
                                name="disposalMethod"
                                value={state.disposalMethod}
                                label="Disposal method"
                                onChange={this.onChange}
                                style={{ width: "600px"}}
                            />
                        </div>
                    </div>
                    <OrangeButton
                        variant="contained"
                        color="secondary"
                        startIcon={<HighlightOffTwoTone />}
                        size="small"
                        onClick={this.onClear}
                        style={{ marginTop: '20px', marginBottom: '20px', marginRight: '20px', float: "left" }}
                    >
                        CLEAR FORM
                    </OrangeButton>
                    <GreenButton
                        variant="contained"
                        color="secondary"
                        startIcon={<AddCircleTwoTone />}
                        size="small"
                        onClick={this.onSave}
                        style={{ marginTop: '20px', marginBottom: '20px', float: "left" }}
                    >
                        SAVE
                    </GreenButton>
                </div>
                </React.Fragment>}
                {!isDemo && <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={this.export} style={{ float: 'right' }}>EXPORT</GreenButton>}
                <div style={{ paddingTop: '60px', paddingLeft: "30px", paddingRight: '30px', width: '1000px' }}>
                    <Typography component="h2" variant="h5">
                        DOCUMENT RETENTION AND DISPOSITION
                    </Typography>
                    <TableComponent
                        tableKey="documentRetentionTable"
                        data={state.documentRetentionRecords}
                        columns={columns}
                        handleSubmit={this.handleSubmit}
                        handleAddRow={this.handleAddRow}
                        handleRowDel={this.onDelete}
                        handleRowEdit={this.onEdit}
                        pagination={true}
                        allowUpdateDelete={isAuditor ? 'no' : 'yes'}
                    />
                </div>
                </CardContent>
                </Card>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={state.show}
                    onClose={() => this.closeModal(null)}
                >
                    <CommonRevisionModal latestRevisionDto={state.latestRevision} addRevision={this.addRevision}/>
                </Modal>
            </Paper>
            <NotificationContainer/>
        </div>;
    }
}

export default withStyles(classes)(DocumentRetention);